import { StyleSheet, Text, View } from '@react-pdf/renderer';
import { getColorObjectStyleByRecord, getColorStylesByRecord } from 'PDF/helpers/documentStyle';

import { RoundDiagramImage } from '../RoundDiagramWithStepsAndPhoto/RoundDiagramImage';
import { RoundDiagramStep } from '../RoundDiagramWithStepsAndPhoto/RoundDiagramStep';

const LONG_SUM_TEXT_LENGTH = 2500;
interface IProps {
  companyImageSrc: string;
  companyName: string;
  items: {
    step: string;
    name: string;
    description: string;
  }[];
}
const colorIndexes = {
  green: [2, 12, 10, 7, 8, 16],
  blue: [2, 5, 10, 0, 6, 15],
  red: [2, 5, 21, 0, 6, 16],
  blueGreen: [2, 5, 10, 0, 28, 8],
  blueRed: [2, 1, 10, 36, 8, 18],
  blueYellow: [35, 29, 36, 10, 8, 9],
};

const colorIndexesTitle = {
  green: 7,
  blue: 0,
  red: 0,
  blueGreen: 0,
  blueRed: 36,
  blueYellow: 0,
};

const sumLengths = (items: IProps['items']): number => {
  return items.reduce((total, item) => {
    return total + item.name.length + item.description.length;
  }, 0);
};

export const ProductCharacteristics = ({ companyImageSrc, companyName, items }: IProps) => {
  const colors = getColorStylesByRecord(colorIndexes);

  return (
    <View style={styles.sectionWrapper} wrap={false}>
      <Text style={[styles.productName, getColorObjectStyleByRecord(colorIndexesTitle, 'color')]}>
        {companyName || 'Product/Service Name'}
      </Text>
      <View style={styles.container}>
        <RoundDiagramImage imgSrc={companyImageSrc} length={items.length} colors={colors} />
        <View style={styles.infoContainer}>
          {items.map((item, index) => (
            <RoundDiagramStep
              smallFontSize={sumLengths(items) > LONG_SUM_TEXT_LENGTH}
              key={item.step}
              stepInfo={item}
              stepsQuantity={items.length}
              isLastOne={index === items.length - 1}
              colors={colors}
            />
          ))}
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  sectionWrapper: {
    marginBottom: 19,
  },
  productName: {
    fontFamily: 'Noto',
    fontSize: '9px',
    fontWeight: 500,
    marginBottom: '18px',
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    alignContent: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
  },
  infoContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
});
